/**
 * ふりがな自動入力
 */
$(function() {
  $.fn.autoKana('#name_sei', '#kana_sei');
  $.fn.autoKana('#name_mei', '#kana_mei');
});

/**
 * 生年月日プルダウン生成
 */
$(function() {
  const now = new Date();
  const currentYear = now.getFullYear();
  const minYear = currentYear - 60;
  const maxYear = currentYear - 18;

  const $year = $('#birthday_year');
  const $month = $('#birthday_month');
  const $day = $('#birthday_day');

  const oldYear = $year.data('old') || '';
  const oldMonth = $month.data('old') || '';
  const oldDay = $day.data('old') || '';

  // 年の選択肢を生成
  for (let y = maxYear; y >= minYear; y--) {
    $year.append($('<option>', { value: y, text: y, selected: oldYear !== '' && String(y) === String(oldYear) }));
  }

  // 月の選択肢を生成
  for (let m = 1; m <= 12; m++) {
    $month.append($('<option>', { value: m, text: m, selected: oldMonth !== '' && String(m) === String(oldMonth) }));
  }

  // 日の選択肢を更新
  function updateDays() {
    const year = parseInt($year.val());
    const month = parseInt($month.val());
    const daysInMonth = (year && month) ? new Date(year, month, 0).getDate() : 31;
    const currentDay = $day.val();
    const restoreDay = oldDay || currentDay;

    $day.find('option:not(:first)').remove();
    for (let d = 1; d <= daysInMonth; d++) {
      $day.append($('<option>', { value: d, text: d, selected: restoreDay !== '' && String(d) === String(restoreDay) }));
    }
  }

  // 年齢を計算して表示
  function updateAge() {
    const year = parseInt($year.val());
    const month = parseInt($month.val());
    const day = parseInt($day.val());
    const $age = $('#birthday_age');
    if (year && month && day) {
      const today = new Date();
      var age = today.getFullYear() - year;
      var m = today.getMonth() + 1 - month;
      if (m < 0 || (m === 0 && today.getDate() < day)) {
        age--;
      }
      $age.text('（' + age + '歳）');
    } else {
      $age.text('');
    }
  }

  $year.on('change', function() { updateDays(); updateAge(); });
  $month.on('change', function() { updateDays(); updateAge(); });
  $day.on('change', updateAge);
  updateDays();
  updateAge();
});

/**
 * PDFアップロード（ドラッグ&ドロップ対応）
 */
$(function() {
  $('.js-dropzone').each(function() {
    var $dropzone = $(this);
    var targetId = $dropzone.data('target');
    var $input = $('#' + targetId);
    var $fileInfo = $('#' + targetId + '-file-info');
    var $hiddenPath = $('input[name="' + targetId + '_path"]');
    var $hiddenName = $('input[name="' + targetId + '_original_name"]');

    function showFileInfo(file) {
      $dropzone.hide();
      $fileInfo.html(
        '<span class="c-form-upload__file-info-name">' + $('<span>').text(file.name).html() + '</span>' +
        '<span class="c-form-upload__file-info-remove js-file-remove">削除</span>'
      );
    }

    // クリックでファイル選択
    $dropzone.on('click', function() {
      $input.trigger('click');
    });

    $input.on('change', function() {
      if (this.files && this.files[0]) {
        showFileInfo(this.files[0]);
        $hiddenPath.val('');
        $hiddenName.val('');
        $input.valid();
      }
    });

    // ドラッグ&ドロップ
    $dropzone.on('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).addClass('--dragover');
    });
    $dropzone.on('dragleave drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).removeClass('--dragover');
    });
    $dropzone.on('drop', function(e) {
      var files = e.originalEvent.dataTransfer.files;
      if (files.length > 0) {
        $input[0].files = files;
        $input.trigger('change');
      }
    });

    // 削除ボタン
    $fileInfo.on('click', '.js-file-remove', function() {
      $input.val('');
      $fileInfo.empty();
      $dropzone.show();
      $hiddenPath.val('');
      $hiddenName.val('');
    });

    // 確認画面から戻った場合：既存ファイル名を表示
    var oldName = $fileInfo.data('old-name');
    if (oldName) {
      showFileInfo({ name: oldName });
    }
  });
});

/**
 * 希望連絡方法：電話　の場合に希望連絡時間帯を表示
 */
const judgeContactTimeShowOrNot = function() {
  const isChecked = $('#contact_way1').prop('checked')
  const $contactTime = $('#form-item-contact-time');
  if (isChecked) {
    $contactTime.show();
  } else {
    $contactTime.hide();
  }
}
$(function () {
  $('#contact_way1').on('change', function() {
    judgeContactTimeShowOrNot();
  })
  judgeContactTimeShowOrNot();
})
